import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-map-context-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './map-context-menu.component.html',
  styleUrls: ['./map-context-menu.component.scss']
})
export class MapContextMenuComponent {
  @Input() show: boolean = false;
  @Input() position: { top: number; left: number } = {top: 0, left: 0};
  @Input() contextData: any = null;
  @Input() options: { addPoint: boolean; zoom: boolean; uploadGeoImage: boolean } = {
    addPoint: true,
    zoom: true,
    uploadGeoImage: false,
  };
  @Output() addPoint = new EventEmitter<any>();
  @Output() zoom = new EventEmitter<any>();
  @Output() uploadGeoImage = new EventEmitter<any>();
  @Output() close = new EventEmitter<void>();

  onAddPoint(): void {
    this.addPoint.emit(this.contextData);
    this.closeMenu();
  }

  onZoom(): void {
    this.zoom.emit(this.contextData);
    this.closeMenu();
  }

  onUploadGeoImage(): void {
    this.uploadGeoImage.emit(this.contextData);
    this.closeMenu();
  }

  closeMenu(): void {
    this.show = false;
    this.close.emit();
  }
}
